const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Crear registro de prenda con tag RFID
 */
export const createRegistroPrendaRfid = async (data) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al crear registro');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en createRegistroPrendaRfid:', error);
    throw error;
  }
};

/**
 * Actualizar registro de prenda RFID
 */
export const updateRegistroPrendaRfid = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al actualizar registro');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en updateRegistroPrendaRfid:', error);
    throw error;
  }
};

/**
 * Eliminar registro de prenda RFID
 */
export const deleteRegistroPrendaRfid = async (id) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al eliminar registro');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en deleteRegistroPrendaRfid:', error);
    throw error;
  }
};

/**
 * Obtener registros con filtros y paginación
 */
export const fetchRegistrosPrendasRfid = async (filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 20 } = filters;
    const response = await fetch(`${API_URL}/registro-prendas-rfid/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, page, limit }),
    });
    if (!response.ok) throw new Error('Error al obtener registros');
    const result = await response.json();
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error en fetchRegistrosPrendasRfid:', error);
    throw error;
  }
};

/**
 * Buscar prenda por tag RFID (lectura individual)
 */
export const findByTagRfid = async (tagRfid) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/tag/${encodeURIComponent(tagRfid)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al buscar tag');
    return await response.json();
  } catch (error) {
    console.error('Error en findByTagRfid:', error);
    throw error;
  }
};

/**
 * Buscar prendas por múltiples tags (lectura masiva con antena)
 */
export const findByTagsRfid = async (tags) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/tags`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tags }),
    });
    if (!response.ok) throw new Error('Error al buscar tags');
    return await response.json();
  } catch (error) {
    console.error('Error en findByTagsRfid:', error);
    throw error;
  }
};

/**
 * Obtener registro por ID
 */
export const fetchRegistroPrendaRfidById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al obtener registro');
    return await response.json();
  } catch (error) {
    console.error('Error en fetchRegistroPrendaRfidById:', error);
    throw error;
  }
};

/**
 * Obtener registros por cliente
 */
export const fetchRegistrosByCliente = async (clienteId, limit = 20, page = 1) => {
  try {
    const response = await fetch(`${API_URL}/registro-prendas-rfid/cliente/${clienteId}?limit=${limit}&page=${page}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al obtener registros del cliente');
    const result = await response.json();
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error en fetchRegistrosByCliente:', error);
    throw error;
  }
};
